module.exports = __webpack_public_path__ + "static/media/percent-bg.94ec8cbd.png";